import { render } from "./PPSSetup.vue?vue&type=template&id=6835b024"
import script from "./PPSSetup.vue?vue&type=script&lang=js"
export * from "./PPSSetup.vue?vue&type=script&lang=js"

import "./PPSSetup.vue?vue&type=style&index=0&id=6835b024&lang=css"
script.render = render

export default script